import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

import { axios } from 'lib';
import { parsePrice } from '../validation';

const createApplication = ({ jobAdID, values }) => {
  const formData = new FormData();

  formData.append('first_name', values.firstName);
  formData.append('last_name', values.lastName);
  formData.append('price_per_hour', parsePrice(values.pricePerHour));
  formData.append('motivation', values.motivation || '');
  formData.append('contact_user_id', values.contactUserID);
  if (values.preferredPlaceID) formData.append('preferred_place_id', values.preferredPlaceID);
  formData.append('cv', values.cv);
  (values.files || []).forEach((file) => formData.append('files', file));

  return axios.post(`/api/job_ads/${jobAdID}/applications`, formData);
};

export const useCreateApplication = (onSuccess) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: createApplication,
    onSuccess: () => {
      enqueueSnackbar('Your application was successfully sent', { variant: 'success' });
      if (onSuccess) onSuccess();
    },
    onError: (error) => {
      enqueueSnackbar(error?.response?.data?.error || error?.message || 'Some error occured', { variant: 'error' });
    },
  });
};
